<template>
  <el-dialog
    class="dev-picker"
    title="批量加载模型"
    :visible.sync="dialogShow"
    width="900px"
    :modal-append-to-body="true"
    :close-on-click-modal="false"
    append-to-body
    :before-close="close"
  >
    <div v-loading="loading">
      <div v-if="step == 0">
        <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
          <el-tab-pane :disabled="importLoading" label="筛选导入设备" name="first" class="flex-center" style="height: 360px;">
            <el-form
              v-if="!importLoading && !importResult"
              ref="selectForm"
              :model="formData"
              :rules="rules"
              label-width="100px"
              label-position="left"
              style="width: 360px;"
            >
              <el-form-item label="当前模型" prop="devid">
                <f-dev-selector v-model="formData.devid" :show-not-load="true" :clearable="false" placeholder="选择模型" width="260" />
              </el-form-item>
              <el-form-item label="预充时长">
                <el-select v-model="formData.precharge_month" placeholder="选择预充时长" style="width: 260px;">
                  <el-option v-for="(item,index) in selectOptions" :key="index" :label="item.label" :value="item.precharge_month" />
                </el-select>
              </el-form-item>
              <el-form-item label="移交时间">
                <span slot="label">
                  <el-popover placement="top" width="200" trigger="hover" content="接入点最近一次移交至本账号的时间">
                    <span slot="reference">
                      移交时间
                      <i class="iconfont icon-circle-question text-muted"></i>
                    </span>
                  </el-popover>
                </span>
                <f-date-range-picker
                  v-model="formData.createtime"
                  :shortcuts="[0, -1, 'this-week', 'this-month', 'last-month']"
                  style="width: 260px;"
                />
              </el-form-item>
            </el-form>
            <div v-if="importLoading" class="flex-center column" style="height: 100%">
              <img class="parse-img" src="@/assets/parse.gif" />
              <div class="font-md">正在导入数据······</div>
            </div>
            <div v-if="importResult && !loadList.length" class="flex column" style="width: 100%;width: 550px;">
              <div style="margin-top: 0px;display: flex;flex-direction: column;align-items: center;">
                <img src="../../../assets/no-equip.png" style="width: 200px;height: 200px;">
                <div style="margin-top: -40px;">暂无符合条件的设备</div>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane
            :disabled="importLoading"
            label="文件导入设备"
            name="second"
            style="height: 360px;"
            class="flex column align-items-center"
          >
            <div v-if="!importLoading">
              <div v-if="!importResult">
                <el-upload
                  v-loading="uploading"
                  drag
                  accept=".xls, .xlsx"
                  ref="upload"
                  :action="$store.state.commonStore.fileUploadUrl"
                  :headers="uploadHeaders"
                  :multiple="false"
                  :limit="1"
                  :on-change="handleChange"
                  :file-list="fileList"
                  :before-upload="beforeUpload"
                  :on-error="handleUploadFail"
                  :on-success="handleUploadSuccess"
                  :on-remove="handleRemove"
                  style="margin-top: 100px;"
                >
                  <i class="el-icon-upload"></i>
                  <div class="el-upload__text">
                    <!-- <div class="mb">将 Excel 文件拖拽到此处</div> -->
                    <el-button size="mini" type="primary">点击上传</el-button>
                  </div>
                </el-upload>
                <div class="mt mb flex-center align-items-center">
                  导入格式请参考
                  <el-link type="primary" :href="templeteUrl">模板</el-link>
                </div>
              </div>
              <div v-if="importResult" class="flex column" style="width: 100%;width: 550px;">
                <div v-if="loadList.length" style="font-size: 18px;" class="mt-sm mb-sm flex-center text-black">
                  <span>
                    导入完成！成功<span class="text-success mr-xs ml-xs">{{ importSuccess }}</span> 台设备
                  </span>
                  <span v-if="importFail">，</span>
                  <span v-if="importFail">
                    失败<span class="text-danger mr-xs ml-xs">{{ importFail }}</span> 台
                  </span>
                </div>
                <el-table v-if="importRecordList.length" ref="importTable" :data="importRecordList" tooltip-effect="dark" :max-height="loadList.length ? 320 : 360" :row-style="{ height: '48px' }">
                  <el-table-column type="index" width="60" label="#" />
                  <el-table-column prop="go" label="设备名称" min-width="160" />
                  <el-table-column label="失败原因" min-width="160" show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span class="text-danger">{{ scope.row.reason }}</span>
                    </template>
                  </el-table-column>
                </el-table>
                <div v-else-if="importRecordList.length == 0 && loadList.length == 0" style="margin-top: 100px;display: flex;flex-direction: column;align-items: center;">
                  <img src="../../../assets/no-equip.png" style="width: 200px;height: 200px;">
                  <div style="margin-top: -40px;">暂无符合条件的设备</div>
                </div>
              </div>
            </div>
            <div v-else-if="importLoading" class="flex-center column" style="height: 100%">
              <img class="parse-img" src="@/assets/parse.gif" />
              <div class="font-md">正在导入数据······</div>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>

      <div v-if="step == 1">
        <div style="font-size: 18px;" class="text-green mb-md">
          将为下列 {{ loadList.length }} 台设备加载 <f-dev-selector v-model="devid" placeholder="选择模型" width="160" @change="loadDev" /> 模型<span v-if="dev.default_rms_schemeid">，并采用 <span class="text-black">{{ dev.rms_scheme_title + ' ￥' + dev.rms_scheme_price + '/年'}}</span> 的收费方案</span>
        </div>
        <el-scrollbar :native="false" v-loading="dev_load_loading">
          <el-table ref="devsTable" :data="loadList" tooltip-effect="dark" :row-style="{ height: '48px' }">
            <el-table-column type="index" width="60" label="#" />
            <el-table-column prop="go" label="设备名称" min-width="160" />
            <el-table-column :show-overflow-tooltip="true" label="模型" min-width="160">
              <div slot-scope="scope" style="line-height: 16px;">
                <div v-if="scope.row.devid && scope.row.devid != devid" class="text-danger">
                  <s>{{ scope.row.dev_name }}</s>
                </div>
                <div v-if="devid">{{ dev_name }}</div>
              </div>
            </el-table-column>
          </el-table>
        </el-scrollbar>
      </div>
      <div v-else-if="step == 2">
        <div v-if="dev_load_loading" style="font-size: 18px;" class="text-green mt-md mb-md flex align-items-center">
          正在为下列 {{ loadList.length }} 台设备加载
          <span class="ml-xs mr-xs" style="color: black;">{{dev_name}}</span> 模型
        </div>
        <div v-if="loading_result" style="font-size: 18px;" class="mt-md mb-md text-black">
          <span v-if="success_num">
            成功加载
            <span class="text-success">{{ success_num }}</span> 台设备
          </span>
          <span v-if="success_num && fail_num">，</span>
          <span v-if="fail_num">
            失败
            <span class="text-danger">{{ fail_num }}</span> 台
          </span>
        </div>
        <el-scrollbar :native="false" ref="scrollbar">
          <el-table ref="devsTable2" :data="list2" tooltip-effect="dark" :row-style="{ height: '48px' }">
            <el-table-column type="index" width="60" label="#" />
            <el-table-column prop="go" label="设备名称" min-width="160" />
            <el-table-column :show-overflow-tooltip="true" label="模型" min-width="160">
              <template slot-scope="scope">
                <span>{{ scope.row.dev_name }}</span>
              </template>
            </el-table-column>
            <el-table-column label="结果" align="center" min-width="80" :show-overflow-tooltip="true">
              <template slot-scope="scope">
                <span v-if="scope.row.loading" class="text-warning">
                  正在加载
                  <span style="font-size: 14px;color: #f0ad4e" class="el-icon-loading ml-xs"></span>
                </span>
                <span v-else :class="scope.row.status == 1 ? 'text-green' : 'text-danger'">{{scope.row.status == 1 ? "成功" : scope.row.err_message}}</span>
              </template>
            </el-table-column>
          </el-table>
        </el-scrollbar>
      </div>
    </div>
    <span slot="footer" class="dialog-footer flex justify-content-center" style="height: 36px;">
      <template v-if="!importLoading">
        <el-button v-if="step == 0 && activeName == 'first' && !importResult" @click="dialogShow = false" class="extend">取消</el-button>
        <el-button v-if="step == 0 && activeName == 'first' && !importResult" type="primary" @click="importEquip()" class="extend">导入</el-button>
        <el-button v-if="step == 0 && importResult" @click="closeDialog" class="extend">关闭</el-button>
        <el-button v-if="step == 0 && activeName == 'second' && importResult && importSuccess" type="primary" @click="nextStep()" class="extend">下一步</el-button>
        <el-button v-if="step == 1" @click="clearAll()" class="extend">清空</el-button>
        <el-button v-if="step == 1" type="primary" :disabled="!devid" @click="submit" class="extend">开始</el-button>
        <el-button v-if="step == 2 && loading_result && success_num == loadList.length" type="primary" plain @click="continueShare" class="extend">继续分享</el-button>
        <el-button v-if="step == 2 && loading_result" @click="closeDialog" class="extend">关闭</el-button>
        <span v-if="step == 2 && list2.length && !loading_result" class="text-warning">
          正在加载中，已完成 {{ finish_num }} / {{ loadList.length }}
          <span class="ml-sm el-icon-loading" style="font-size: 16px;color: #f0ad4e"></span>
        </span>
      </template>
    </span>
  </el-dialog>
</template>

<script>
import { loadDevApi } from '@/api/rms/rmsEquipDevApi'
import { equipAllFilterApi, importCheckApi } from '@/api/rms/rmsEquipApi'
import XLSX from 'xlsx'
import { getUploadHeaders } from '@/utils/uploadHeaders'

export default {
  name: "DevPicker",
  props: {
    show: {
      type: Boolean,
      default: false
    },
    list: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      loading: false,

      devid: null,
      step: 0,
      loadList: [],
      list2: [],
      dev: {},
      dev_name: null,
      dev_load_loading: false,
      loading_result: false,
      success_num: 0,
      fail_num: 0,
      finish_num: 0,

      activeName: 'first',
      formData: {
        devid: 0,
        precharge_month: 0,
        createtime: []
      },
      rules: {
        devid: [
          {
            required: true,
            message: "请选择模型",
            trigger: "change",
          },
        ],
      },
      selectOptions: [
        {
          key: 'all',
          label: '全部',
          precharge_month: 0,
        },
        {
          key: "one_year",
          label: "1年",
          precharge_month: 12
        },
        {
          key: "two_year",
          label: "2年",
          precharge_month: 24
        },
        {
          key: "three_year",
          label: "3年",
          precharge_month: 36
        },
        {
          key: "four_year",
          label: "4年",
          precharge_month: 48
        },
        {
          key: "five_year",
          label: "5年",
          precharge_month: 60
        },
        {
          key: "six_year",
          label: "6年",
          precharge_month: 72
        }
      ],
      templeteUrl:
        "https://frippler-fcs-res-prod.oss-cn-shenzhen.aliyuncs.com/global/aiot/template/equip_import_template.xlsx",
      fileList: [],
      uploading: false,
      importLoading: false,
      go_arr: [],

      shareEquips: [],
      importResult: false,
      importRecordList: [],
      importSuccess: 0,
      importFail: 0,
    };
  },
  computed: {
    uploadHeaders() {
      return getUploadHeaders(this.$store.getters.accessToken)
    },
    dialogShow: {
      get() {
        return this.show;
      },
      set(val) {
        this.$emit("update:show", val);
      }
    }
  },
  created() {
    if(this.list.length) {
      this.step = 1;
      this.loadList = this.list;
    } else {
      this.step = 0;
    }
  },
  methods: {
    handleClick(tab, event) {
      this.activeName = tab.name;
      this.importResult = false
      this.handleRemove()
    },
    importEquip() {
      const delay = (ms) => new Promise(resolve => setTimeout(resolve, ms));
      this.importLoading = true;
      const params = {
        devid: this.formData.devid,
        precharge_month: this.formData.precharge_month,
      }
      if(this.formData.createtime && this.formData.createtime.length) {
        params.startime = this.formData.createtime[0];
        params.endtime = this.formData.createtime[1];
      } else {
        delete params.startime;
        delete params.endtime;
      }
      delay(1000).then(() => {
        equipAllFilterApi(params).then(res =>{
          this.importLoading = false;
          if(!res.errno) {
            this.importResult = true
            this.loadList = res.data;
            this.importSuccess = res.data.length;
            if (this.importSuccess) this.step = 1;
          } else {
            this.$message.error(res.message);
          }
        })
      })
    },
    nextStep() {
      this.step = 1
    },
    clearAll() {
      this.loadList = [];
      this.importRecordList = [];
      this.fileList = [];
      this.importResult = false;
      this.step = 0;
      this.go_arr = [];
      this.importFail = 0;
      this.importSuccess = 0;
    },

    beforeUpload(file) {
      const isExcel = file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' || file.type === 'application/vnd.ms-excel';
      const fileSize = file.size / 1024 / 1024 < 2;
      if (!isExcel) {
        this.$message.error('只支持上传Excel文件！');
        return false
      }
      if (!fileSize) {
        this.$message.error('文件大小不能超过2MB！');
        return false;
      }
      this.uploading = true;
      return true;
    },
    handleChange(file, filelist) {
      this.fileList = filelist;
    },
    handleUploadFail(err, file, fileList) {
      this.uploading = false;
      this.$message.error("文件上传失败");
    },
    handleUploadSuccess(response, file, fileList) {
      this.readExcelFile(file).then(data => {
        const temp = data.slice(0,100).map(item => item.GO)
        this.go_arr = [...new Set(temp)];
        this.confirmImport();
      })
      this.uploading = false;
    },

    readExcelFile(file) {
      return new Promise((resolve, reject) => {
        let reader = new FileReader();
        reader.readAsBinaryString(file.raw);
        reader.onload = (ev) => {
          try {
            let dataBinary = ev.target.result;
            let workBook = XLSX.read(dataBinary, {
              type: "binary",
              cellDates: true,
            });
            let workSheet = workBook.Sheets[workBook.SheetNames[0]];
            const data = XLSX.utils.sheet_to_json(workSheet); //这里已经能拿到转换后的json
            resolve(data);
          } catch (err) {
            reject(err);
          }
        };
        reader.onerror = (ev) => {
          reject("文件读取失败");
        };
      });
    },

    handleRemove(file, fileList) {
      this.fileList = fileList;
      this.go_arr = [];
    },

    confirmImport() {
      this.importLoading = true;
      const delay = (ms) => new Promise(resolve => setTimeout(resolve, ms));
      delay(1000).then(() => {
        if(!this.go_arr.length) {
          this.importRecordList = []
          this.importResult = true;
          this.importLoading = false;
          this.importSuccess = 0;
          this.importFail = 0;
          return;
        }
        importCheckApi({ go_arr: this.go_arr }).then(res => {
          if (!res.errno) {
            this.loadList = res.data.success;
            this.importResult = true;
            this.importSuccess = res.data.success.length;
            this.importFail = res.data.fail.length;
            if(res.data.fail.length) {
              this.importRecordList = res.data.fail;
            } else {
              this.step = 1;
            }
          } else {
            this.$message.error(res.message);
          }
          this.importLoading = false;
        })
      })
    },

    async submit() {
      this.list2 = [];
      this.step = 2;
      for(let i = 0; i < this.loadList.length; i++) {
        this.dev_load_loading = true;
        const temp_item = Object.assign({},{...this.loadList[i]});
        this.list2.push(Object.assign({}, temp_item,{dev_name: this.dev_name,loading: true}));
        const res = await loadDevApi({ equipid: temp_item.equipid, devid: this.devid });
        this.finish_num += 1;
        if (!res.errno) {
          this.list2[i].loading = false;
          this.list2[i] = Object.assign({}, this.list2[i],{loading: false, status: 1});
        }else {
          this.list2[i].loading = false;
          this.list2[i] = Object.assign({}, this.list2[i],{loading: false, status: 0,err_message: res.message});
        }

        if (this.list2.length > 5) {
          this.$nextTick(() => {
            this.scrollToBottom();
          });
        }
        if(i == this.loadList.length - 1) {
          this.dev_load_loading = false;
          this.loading_result = true;
          this.success_num = 0;
          this.fail_num = 0;
          for(let j = 0; j < this.list2.length; j++) {
            if(this.list2[j].status == 1) {
              this.success_num++;
            }else {
              this.fail_num++;
            }
          }
        }
      }
      this.$emit('change')
    },

    scrollToBottom() {
      const scrollbar = this.$refs.scrollbar;
      if (scrollbar) {
        scrollbar.wrap.scrollTop = scrollbar.wrap.scrollHeight;
      }
    },

    loadDev(e) {
      this.dev = Object.assign({}, e)
      this.dev_name = e.dev_name;
    },

    continueShare() {
      this.shareEquips = this.loadList.map(item => {
        if(!item.user_auth) {
          item.user_auth = item.auth_level
        }
        item.name = item.go
        return item
      });
      this.$emit('share', this.shareEquips);
      this.closeDialog();
    },

    closeDialog() {
      this.dialogShow = false;
      this.step = 1;
      this.devid = null;
      this.list2 = [];
      this.loading_result = false;
      this.success_num = 0;
      this.fail_num = 0;
      this.finish_num = 0;
      this.importLoading = false;
      this.dev_load_loading = false;
      this.importResult = false;
      this.shareEquips = [];
      this.importRecordList = [];
      this.go_arr = [];
      this.fileList = [];
    },

    close() {
      if(this.importLoading) {
        this.$confirm('正在导入，请耐心等待载完成', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        return false
      }
      if(this.dev_load_loading) {
        this.$confirm('正在加载模型中，请耐心等待加载完成', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        return false
      }
      this.closeDialog()
    },
  }
};
</script>

<style lang="scss">
.dev-picker {
  .el-scrollbar {
    height: 360px;
    > .el-scrollbar__wrap {
      overflow-x: hidden;
      > .el-scrollbar__view {
        padding: 0 10px 20px 0;
      }
    }
  }
  .el-dialog__body {
    padding-top: 10px
  }
  .el-dialog__footer {
    padding-bottom: 30px;
  }
  .parse-img {
    height: 194px;
  }
}
</style>
